import type {BaseComponentPart, StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';

export interface WebSource {
  title: string;
  url: string;
  domain: string;
}

export type WebSourcesVariant = 'search' | 'read';

/** What a web-sources line and its loading placeholder say and show for one variant. */
export interface WebSourcesVariantCopy {
  icon: string;
  oneSourceKey: string;
  manySourcesKey: string;
  loadingKey: string;
}

export const WEB_SOURCES_VARIANT_COPY: Record<WebSourcesVariant, WebSourcesVariantCopy> = {
  search: {icon: 'icon-search', oneSourceKey: 'pmwjs_ai_chat_web_sources_searched_one', manySourcesKey: 'pmwjs_ai_chat_web_sources_searched_other', loadingKey: 'pmwjs_ai_chat_web_sources_searching'},
  read: {icon: 'icon-link', oneSourceKey: 'pmwjs_ai_chat_web_sources_read_one', manySourcesKey: 'pmwjs_ai_chat_web_sources_read_other', loadingKey: 'pmwjs_ai_chat_web_sources_reading'},
};

/** The pages a web search cited, or the link a read opened, shown under the reply that used them. */
export interface WebSourcesProps {
  variant: WebSourcesVariant;
  sources: WebSource[];
}

export type WebSourcesComponentPart = BaseComponentPart<StreamComponentType.WEB_SOURCES, WebSourcesProps>;

export const MAX_STACKED_FAVICONS = 4;
